import Qwoted100Badge from "./Qwoted100Badge";

export default Qwoted100Badge;
